// @flow

import localforage from 'localforage';
import * as R from 'ramda';

import { STORAGE_KEY_DRAFT } from '~/helpers';

export const resolvers = {
  Query: {
    draft: async (
      // $FlowIssue
      _, // eslint-disable-line no-unused-vars
      { id }: DraftQueryInput,
      { cache }: ApolloCache,
    ): Promise<?Draft> => {
      // $FlowIssue
      const values = await localforage.getItem(`${STORAGE_KEY_DRAFT}${id}`);

      const draft = R.isNil(values)
        ? null
        : { id, values, __typename: 'Draft' };

      cache.writeData({ data: { draft } });

      return draft;
    },
  },
  Mutation: {
    updateDraftMutation: async (
      // $FlowIssue
      _, // eslint-disable-line no-unused-vars
      { values: { id, raw } }: DraftInputMutation,
    ): Promise<MessagePayload> => {
      if (R.isNil(raw)) {
        await localforage.removeItem(`${STORAGE_KEY_DRAFT}${id}`);
      } else {
        await localforage.setItem(`${STORAGE_KEY_DRAFT}${id}`, raw);
      }

      return {
        code: 0,
        message: 'Done',
        __typename: 'MessagePayload',
      };
    },
  },
};
